/** @jsx jsx */
import { useContext } from "react"
import { useStaticQuery, graphql } from "gatsby"
import { useTransition, animated as a } from "react-spring"
import { Button, Box, Text, jsx } from "theme-ui"
import BlockContent from "@sanity/block-content-to-react"

import { Context } from "../../context/MainContext"
import { HowItWorks } from "../svg"

const styles = {
  container: {
    backgroundColor: "#FFF",
    display: "grid",
    gridGap: "0px",
    gridTemplateColumns: "1fr",
    gridTemplateRows: "auto 1fr auto",
    height: "100vh",
    minHeight: "100%",
    minWidth: "100%",
    left: "0px",
    margin: "0px",
    maxHeight: "-webkit-fill-available",
    padding: "20px 8px",
    position: "fixed",
    top: "0px",
    width: "100vw",
    zIndex: 110,
    fontSize: "18px",
  },
  content: {
    p: {
      color: "#333",
      margin: "1em 0",
    },
  },
}

function HowItWorksModal() {
  const {
    store: { isHowItWorksOpen },
    toggleHowItWorksOpen,
  } = useContext(Context)

  const transitions = useTransition(isHowItWorksOpen, null, {
    from: { opacity: 0 },
    enter: { opacity: 1 },
    leave: { opacity: 0 },
    duration: 1000,
  })

  const data = useStaticQuery(graphql`
    query HowItWorksModalQuery {
      sanityCaseBuilder(_id: { eq: "caseBuilder" }) {
        howItWorks: _rawHowItWorks
      }
    }
  `)

  const BlockRenderer = props => {
    if (props.node.style === "normal") {
      return (
        <Text as="p" variant="secondary" color="#333">
          {props.children}
        </Text>
      )
    }
    return BlockContent.defaultSerializers.types.block(props)
  }

  const { howItWorks } = data.sanityCaseBuilder

  return transitions.map(
    ({ item, key, props }) =>
      item && (
        <a.div
          key={key}
          style={props}
          tabIndex="0"
          id="how-it-works"
          sx={styles.container}
        >
          {/* HEADER */}
          <Box sx={{ width: "100%", gridRow: 1, gridColumn: 1 }}>
            <Button
              onClick={() => toggleHowItWorksOpen()}
              sx={{
                height: "55px",
                backgroundColor: "transparent",
                padding: "0px",
              }}
            >
              <HowItWorks active={isHowItWorksOpen} />
              <Text
                as="span"
                variant="secondary"
                sx={{
                  color: "#333",
                  fontSize: "14px",
                  marginLeft: "10px",
                }}
              >
                CLOSE
              </Text>
            </Button>
          </Box>

          {/* INNNER */}
          <Box
            sx={{
              width: "100%",
              gridRow: 2,
              gridColumn: 1,
              overflowY: "scroll",
              ...styles.content,
            }}
          >
            <Text variant="secondary" as="p">
              {"HOW IT WORKS"}
            </Text>
            <BlockContent
              blocks={howItWorks}
              serializers={{
                types: {
                  block: BlockRenderer,
                },
              }}
            />
          </Box>
        </a.div>
      )
  )
}

export default HowItWorksModal
